/**
 * Local: empty base → /media/videos/...
 * Production: set VITE_MEDIA_BASE_URL to your public R2/CDN URL
 *   e.g. https://media.aiasmusic.com  (no trailing slash)
 */
const BASE = (import.meta.env.VITE_MEDIA_BASE_URL as string | undefined)?.replace(/\/$/, '') || ''

export function mediaUrl(path: string): string {
  if (!path) return path
  if (path.startsWith('http://') || path.startsWith('https://')) return path
  if (!BASE) return path
  return `${BASE}${path.startsWith('/') ? path : `/${path}`}`
}
